<svg
  width="29"
  height="28"
  viewBox="0 0 29 28"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    x="6.68732"
    y="6"
    width="16"
    height="2.28571"
    rx="1.14286"
    fill="#FF3434"
  />
  <rect
    x="6.68732"
    y="12.8571"
    width="16"
    height="2.28571"
    rx="1.14286"
    fill="#FF3434"
  />
  <rect
    x="6.68732"
    y="19.7143"
    width="16"
    height="2.28571"
    rx="1.14286"
    fill="#FF3434"
  />
  <g filter="url(#filter0_f_654_2375)">
    <rect
      x="6.68732"
      y="6"
      width="16"
      height="2.28571"
      rx="1.14286"
      fill="#FF3434"
    />
    <rect
      x="6.68732"
      y="12.8571"
      width="16"
      height="2.28571"
      rx="1.14286"
      fill="#FF3434"
    />
    <rect
      x="6.68732"
      y="19.7143"
      width="16"
      height="2.28571"
      rx="1.14286"
      fill="#FF3434"
    />
  </g>
  <defs>
    <filter
      id="filter0_f_654_2375"
      x="0.687317"
      y="0"
      width="28"
      height="28"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      />
      <feGaussianBlur
        stdDeviation="3"
        result="effect1_foregroundBlur_654_2375"
      />
    </filter>
  </defs>
</svg>
